export const allMessages = {
    en: {
        langDomain: "",
        locale: "en",
        messages: {
            "en.messages": {
                "The VIN must be 17 characters.": "The VIN must be 17 characters.",
                "The VIN mustn't contain invalid character (I, O or Q).": "Characters I, O and Q are not permitted.",
                "More": "More",
                "Close": "Close",
                "Something went wrong": "Something went wrong.",
                "Saved": "Saved.",
                "Price history": "Price history",
                "Odometer history": "Odometer history"
            },
            "en.my": {"You have to agree to the Terms and Conditions and Privacy Policy": "You have to agree to the Terms and Conditions and Privacy Policy"},
            "en.payment": {
                "We were unable to process your order.": "We were unable to process your order.",
                "Failed to finish your purchase. Please contact customer support!": "Failed to finish your purchase. Please contact customer support!"
            },
            "en.vehicle": {
                "WMI": "WMI",
                "Manufacturer": "Manufacturer",
                "Market": "Market",
                "Make": "Make",
                "Model": "Model",
                "Vehicle Specification": "Vehicle Specification",
                "Vehicle Type": "Vehicle Type",
                "Total weight": "Total weight",
                "Length": "Length",
                "Engine power": "Engine power",
                "queries": "queries",
                "Plate": "Plate",
                "Color": "Color",
                "Evidenced since": "Evidenced since",
                "Last seen at": "Last seen at",
                "International code": "International code",
                "Year": "Year",
                "Motor": "Motor",
                "Plant Company": "Plant Company",
                "Plant City": "Plant City",
                "Plant State": "Plant State",
                "Plant Country": "Plant Country",
                "Equipment": "Equipment",
                "Build Date": "Build Date",
                "Vehicle Line": "Vehicle Line",
                "Body Style": "Body Style",
                "Version": "Version",
                "Cab Style": "Cab Style",
                "Series": "Series",
                "Engine": "Engine",
                "Drive": "Drive",
                "Axle Ratio": "Axle Ratio",
                "Emission": "Emission",
                "Territory": "Territory",
                "Paint": "Paint",
                "Interior Colour": "Interior Colour",
                "Interior Fabric": "Interior Fabric",
                "Trim": "Trim",
                "Body": "Body",
                "Color (interior)": "Color (interior)",
                "Number of Seats": "Number of Seats",
                "Number of Seat Rows": "Number of Seat Rows",
                "Number of Doors": "Number of Doors",
                "Number of Airbags": "Number of Airbags",
                "Number of Axles": "Number of Axles",
                "Steering": "Steering",
                "Length (mm)": "Length (mm)",
                "Width (mm)": "Width (mm)",
                "Height (mm)": "Height (mm)",
                "Weight Empty (kg)": "Weight Empty (kg)",
                "Track Front (mm)": "Track Front (mm)",
                "Track Rear (mm)": "Track Rear (mm)",
                "Wheelbase (mm)": "Wheelbase (mm)",
                "Wheel Size": "Wheel Size",
                "Fuel Type - Primary": "Fuel Type - Primary",
                "Fuel Type - Secondary": "Fuel Type - Secondary",
                "Fuel Capacity": "Fuel Capacity (l)",
                "Fuel Consumption l\/100km (Combined)": "Fuel Consumption l\/100km (Combined)",
                "Fuel Consumption l\/100km (Extra Urban)": "Fuel Consumption l\/100km (Extra Urban)",
                "Fuel Consumption l\/100km (Urban)": "Fuel Consumption l\/100km (Urban)",
                "Engine (full)": "Engine (full)",
                "Engine Code": "Engine Code",
                "Engine Displacement (ccm)": "Engine Displacement (ccm)",
                "Engine Power (kW)": "Engine Power (kW)",
                "Engine Cylinders": "Engine Cylinders",
                "Engine Torque": "Engine Torque (Nm)",
                "Engine Compression Ratio": "Engine Compression Ratio",
                "Engine Model": "Engine Model",
                "Transmission": "Transmission",
                "Transmission (full)": "Transmission (full)",
                "Number of Gears": "Number of Gears",
                "Battery Info": "Battery Info",
                "Battery Type": "Battery Type",
                "Made": "Made",
                "Registered": "Registered",
                "Odometer (km)": "Odometer (km)",
                "Emission Standard": "Emission Standard",
                "CO2 Emission": "CO2 Emission (g\/km)",
                "CO2 Emission (Average)": "CO2 Emission (Average)",
                "Price": "Price",
                "Price Original": "Price Original",
                "Price Currency": "Price Currency",
                "Air Conditioning": "Air Conditioning",
                "Vehicle not affected.": "Vehicle not affected.",
                "Vehicle affected.": "<strong>Vehicle <a href=\":url\" target=\"_blank\">affected<\/a><\/strong>.",
                "Plant code": "Plant code",
                "Manufacturer Address": "Manufacturer Address",
                "Product Type": "Product Type",
                "Check Digit": "Check Digit",
                "Valid Check Digit": "Valid Check Digit",
                "Check Digit Validity": "Check Digit Validity",
                "Model Year": "Model Year",
                "Sequential Number": "Sequential Number",
                "Steering Type": "Steering Type",
                "Power Steering": "Power Steering",
                "Width including mirrors (mm)": "Width including mirrors (mm)",
                "Width mirrors folded (mm)": "Width mirrors folded (mm)",
                "Ride Height (mm)": "Ride Height (mm)",
                "Approach Angle (\u00b0)": "Approach Angle (\u00b0)",
                "Departure Angle (\u00b0)": "Departure Angle (\u00b0)",
                "Ramp Angle (\u00b0)": "Ramp Angle (\u00b0)",
                "Max Weight (kg)": "Max Weight (kg)",
                "Minimum volume of Luggage (trunk)": "Minimum volume of Luggage (trunk)",
                "Maximum volume of Luggage (trunk)": "Maximum volume of Luggage (trunk)",
                "Wheel Rims Size": "Wheel Rims Size",
                "Front Brakes": "Front Brakes",
                "Rear Brakes": "Rear Brakes",
                "Front Suspension": "Front Suspension",
                "Rear Suspension": "Rear Suspension",
                "Front Overhang (mm)": "Front Overhang (mm)",
                "Rear Overhang (mm)": "Rear Overhang (mm)",
                "Drag Coefficient": "Drag Coefficient",
                "Max roof load (kg)": "Max roof load (kg)",
                "Permitted trailer load with brakes 8% (kg)": "Permitted trailer load with brakes 8% (kg)",
                "Permitted trailer load with brakes 12% (kg)": "Permitted trailer load with brakes 12% (kg)",
                "Permitted trailer load without brakes (kg)": "Permitted trailer load without brakes (kg)",
                "Permitted towbar download (kg)": "Permitted towbar download (kg)",
                "Fuel System": "Fuel System",
                "Engine RPM": "Engine RPM",
                "Engine Cylinders Position": "Engine Cylinders Position",
                "Engine Cylinder Bore": "Engine Cylinder Bore",
                "Valves per Cylinder": "Valves per Cylinder",
                "Valve Train": "Valve Train",
                "Engine Position": "Engine Position",
                "Engine Max Speed (rpm)": "Engine Max Speed (rpm)",
                "Engine Manufacturer": "Engine Manufacturer",
                "Engine Oil Capacity (l)": "Engine Oil Capacity (l)",
                "Engine Coolant (l)": "Engine Coolant (l)",
                "Engine Stroke": "Engine Stroke",
                "Engine Turbine": "Engine Turbine",
                "Max Speed (km\/h)": "Max Speed (km\/h)",
                "Acceleration 0-100 km\/h": "Acceleration 0-100 km\/h",
                "Minimum turning circle (turning diameter)": "Minimum turning circle (turning diameter)",
                "Electric Motor Power (kW)": "Electric Motor Power (kW)",
                "Electric Motor RPM": "Electric Motor RPM",
                "Electric Motor Torque (Nm)": "Electric Motor Torque (Nm)",
                "ABS": "ABS",
                "Production Started": "Production Started",
                "Production Stopped": "Production Stopped",
                "Company": "Company",
                "Date": "Date",
                "Acceleration 0-100 km\/h (CNG)": "Acceleration 0-100 km\/h (CNG)",
                "Acceleration 0-100 km\/h (LPG)": "Acceleration 0-100 km\/h (LPG)",
                "Acceleration 0-200 km\/h": "Acceleration 0-200 km\/h",
                "Acceleration 0-300 km\/h": "Acceleration 0-300 km\/h",
                "AdBlue Capacity (l)": "AdBlue Capacity (l)",
                "All Electric Range": "All Electric Range",
                "Average Energy Consumption (kWh\/100 km)": "Average Energy Consumption (kWh\/100 km)",
                "Battery Capacity (kWh)": "Battery Capacity (kWh)",
                "Climb Angle (\u00b0)": "Climb Angle (\u00b0)",
                "CNG Cylinder Capacity (kg)": "CNG Cylinder Capacity (kg)",
                "CO2 Emission (g\/km) (CNG)": "CO2 Emission (g\/km) (CNG)",
                "CO2 Emission (g\/km) (Ethanol)": "CO2 Emission (g\/km) (Ethanol)",
                "CO2 Emission (g\/km) (LPG)": "CO2 Emission (g\/km) (LPG)",
                "Deceleration 100-0 km\/h": "Deceleration 100-0 km\/h",
                "Deceleration 200-0 km\/h": "Deceleration 200-0 km\/h",
                "Electric Motor Power (HP)": "Electric Motor Power (HP)",
                "Electric Motor Torque (RPM)": "Electric Motor Torque (RPM)",
                "Engine Modification": "Engine Modification",
                "Engine Power (HP)": "Engine Power (HP)",
                "Engine Torque (RPM)": "Engine Torque (RPM)",
                "Fuel Capacity (LPG)": "Fuel Capacity (LPG)",
                "Fuel Consumption kg\/100km (Combined) (CNG)": "Fuel Consumption kg\/100km (Combined) (CNG)",
                "Fuel Consumption kg\/100km (Extra Urban) (CNG)": "Fuel Consumption kg\/100km (Extra Urban) (CNG)",
                "Fuel Consumption kg\/100km (Urban) (CNG)": "Fuel Consumption kg\/100km (Urban) (CNG)",
                "Fuel Consumption l\/100km (Combined) (Ethanol)": "Fuel Consumption l\/100km (Combined) (Ethanol)",
                "Fuel Consumption l\/100km (Combined) (LPG)": "Fuel Consumption l\/100km (Combined) (LPG)",
                "Fuel Consumption l\/100km (Extra Urban) (Ethanol)": "Fuel Consumption l\/100km (Extra Urban) (Ethanol)",
                "Fuel Consumption l\/100km (Extra Urban) (LPG)": "Fuel Consumption l\/100km (Extra Urban) (LPG)",
                "Fuel Consumption l\/100km (Urban) (Ethanol)": "Fuel Consumption l\/100km (Urban) (Ethanol)",
                "Fuel Consumption l\/100km (Urban) (LPG)": "Fuel Consumption l\/100km (Urban) (LPG)",
                "Max Speed (km\/h) (CNG)": "Max Speed (km\/h) (CNG)",
                "Max Speed (km\/h) (LPG)": "Max Speed (km\/h) (LPG)",
                "Power (HP) (CNG)": "Power (HP) (CNG)",
                "Power (HP) (Ethanol)": "Power (HP) (Ethanol)",
                "Power (HP) (Ice)": "Power (HP) (Ice)",
                "Power (HP) (LPG)": "Power (HP) (LPG)",
                "Torque (CNG)": "Torque (CNG)",
                "Torque (Ethanol)": "Torque (Ethanol)",
                "Torque (Ice)": "Torque (Ice)",
                "Torque (LPG)": "Torque (LPG)",
                "Wading Depth (mm)": "Wading Depth (mm)",
                "Wheel Rims Size Array": "Wheel Rims Size Array",
                "Wheel Size Array": "Wheel Size Array",
                "Wheelbase Array (mm)": "Wheelbase Array (mm)",
                "Vehicle Type Approval": "Vehicle Type Approval",
                "Vehicle Type Approval (short)": "Vehicle Type Approval (short)",
                "Brake System": "Brake System",
                "Electric Consumption (kWh\/100km)": "Electric Consumption (kWh\/100km)",
                "Electric Consumption (kWh\/100km) (WLTP)": "Electric Consumption (kWh\/100km) (WLTP)",
                "Electric Range From (km)": "Electric Range From (km)",
                "Electric Range From (km) (WLTP)": "Electric Range From (km) (WLTP)",
                "Electric Range To (km)": "Electric Range To (km)",
                "Electric Range To (km) (WLTP)": "Electric Range To (km) (WLTP)",
                "Engine Type": "Engine Type",
                "Number Wheels": "Number Wheels",
                "Suspension": "Suspension",
                "Fuel Consumption l\/100km (Urban) (WLTP)": "Fuel Consumption l\/100km (Urban) (WLTP)",
                "CO2 Emission (WLTP)": "CO2 Emission (WLTP)",
                "Minimum Trunk Capacity (l)": "Minimum Trunk Capacity (l)",
                "Maximum Trunk Capacity (l)": "Maximum Trunk Capacity (l)",
                "Fuel Capacity (l)": "Fuel Capacity (l)",
                "Fuel Consumption Combined (l\/100km)": "Fuel Consumption Combined (l\/100km)",
                "Fuel Consumption Extra Urban (l\/100km)": "Fuel Consumption Extra Urban (l\/100km)",
                "Fuel Consumption Urban (l\/100km)": "Fuel Consumption Urban (l\/100km)",
                "Engine Cylinder Bore (mm)": "Engine Cylinder Bore (mm)",
                "Engine Stroke (mm)": "Engine Stroke (mm)",
                "CO2 Emission (g\/km)": "CO2 Emission (g\/km)",
                "Average CO2 Emission (g\/km)": "Average CO2 Emission (g\/km)"
            },
            "en.frontendValidation": {
                "All good": "All good",
                "There are errors": "There are errors",
                "can't be blank": "can't be blank",
                "minimum %{count} chars": "minimum %{count} chars",
                "maximum %{count} chars": "maximum %{count} chars",
                "is not a valid url": "is not a valid url",
                "is not a valid email": "is not a valid email",
                "is invalid": "is invalid",
                "is not a number": "is not a number",
                "is not an integer": "is not an integer",
                "must be greater than %{count}": "must be greater than %{count}",
                "must be greater than or equal to %{count}": "must be greater than or equal to %{count}",
                "must be equal to %{count}": "must be equal to %{count}",
                "must be less than %{count}": "must be less than %{count}",
                "must be less than or equal to %{count}": "must be less than or equal to %{count}",
                "must be odd": "must be odd",
                "must be even": "must be even",
                "Must be checked": "Must be checked",
                "There is a problem with the Billing Address": "There is a problem with the Billing Address",
                "Card holder name is not valid": "Card holder name is not valid",
                "Card number is not valid": "Card number is not valid",
                "Security code is not valid": "Card CVC is not valid",
                "Expiry date is not valid": "Expiry date is not valid",
                "Card is Expired": "Card is Expired",
                "Card data are not valid": "Card data are not valid",
                "At least one must be greater than zero": "At least one must be greater than zero",
                "VAT ID must begin with a country code": "VAT ID must begin with a country code",
                "Invalid VAT ID": "Invalid VAT ID"
            },
            "en.chart": {
                "Market Value Dynamics: :car": "Market Value Dynamics: :car",
                "Average price (:currency)": "Average price (:currency)",
                "Average odometer (:unit)": "Average odometer (:unit)",
                "Price (:currency)": "Price (:currency)",
                "Vehicle Price Map: :car": "Vehicle Price Map: :car",
                "Odometer (:unit)": "Odometer (:unit)",
                "Market value: :make :model (:year)": "Market value: :make :model (:year)",
                "Price (:currency) \/ Odometer (:lengthUnit): :make :model (:year)": "Price (:currency) \/ Odometer (:lengthUnit): :make :model (:year)",
                "Count of vehicles": "Count of vehicles",
                "Vehicle Market Value": "Vehicle Market Value",
                "Get real insight into a vehicle market.": "Get real insight into a vehicle market.",
                "Following charts provide several layers of information that are key to making informed decisions. No matter whether you're looking to buy, sell or just evaluate a vehicle.": "Following charts provide several layers of information that are key to making informed decisions. No matter whether you're looking to buy, sell or just evaluate a vehicle.",
                "Model Year": "Model Year",
                "Market Value Dynamics": "Market Value Dynamics",
                "Vehicle Price Map": "Vehicle Price Map",
                "Vehicle Price Distribution: :make :model :year": "Vehicle Price Distribution: :make :model :year",
                "Vehicle Price Distribution": "Vehicle Price Distribution",
                "Date": "Date",
                "Mileage": "Mileage",
                "Car mileage": "Car mileage by kilometers driven",
                "Vehicle mileage": "Odometer reading by kilometres driven",
                'Number of vehicle listings in the price range': 'Number of vehicle listings in the price range.',
                "Trendline": "Trendline",
                "Vehicle Value Depreciation": "Vehicle Value Depreciation",
            }
        }
    },
    cs: {
        langDomain: "cz",
        locale: "cs",
        messages: {
            "cs.messages": {
                "The VIN must be 17 characters.": "VIN k\u00f3d mus\u00ed m\u00edt 17 znak\u016f.",
                "The VIN mustn't contain invalid character (I, O or Q).": "VIN k\u00f3d nesm\u00ed obsahovat p\u00edsmena I, O a Q.",
                "More": "V\u00edce",
                "Close": "Zav\u0159\u00edt",
                "Something went wrong": "N\u011bkde se stala chyba.",
                "Saved": "Ulo\u017eeno.",
                "Price history": "Historie cen",
                "Odometer history": "Historie najet\u00fdch km"
            },
            "cs.my": {"You have to agree to the Terms and Conditions and Privacy Policy": "Mus\u00edte souhlasit s Obchodn\u00edmi podm\u00ednkami a Pravidly ochrany osobn\u00edch \u00fadaj\u016f"},
            "cs.payment": {
                "We were unable to process your order.": "Do\u0161lo k chyb\u011b p\u0159i zpracov\u00e1n\u00ed objedn\u00e1vky.",
                "Failed to finish your purchase. Please contact customer support!": "Nepoda\u0159ilo se dokon\u010dit n\u00e1kup. Pros\u00edm, kontaktujte z\u00e1kaznickou podporu!"
            },
            "cs.vehicle": {
                "WMI": "WMI",
                "Manufacturer": "V\u00fdrobce",
                "Market": "Trh",
                "Make": "Zna\u010dka",
                "Model": "Model",
                "Vehicle Specification": "Specifikace vozidla",
                "Vehicle Type": "Typ vozidla",
                "Total weight": "Celkov\u00e1 hmotnost",
                "Length": "D\u00e9lka",
                "Engine power": "V\u00fdkon motoru",
                "queries": "hled\u00e1n\u00ed",
                "Plate": "SPZ",
                "Color": "Barva",
                "Evidenced since": "V evidenci od",
                "Last seen at": "Naposledy vid\u011bno",
                "International code": "Mezin\u00e1rodn\u00ed k\u00f3d",
                "Year": "Rok v\u00fdroby",
                "Motor": "Motor",
                "Plant Company": "V\u00fdrobce",
                "Plant City": "M\u011bsto",
                "Plant State": "Oblast",
                "Plant Country": "Zem\u011b p\u016fvodu",
                "Equipment": "V\u00fdbava",
                "Build Date": "Datum v\u00fdroby",
                "Vehicle Line": "Vehicle Line",
                "Body Style": "Karoserie",
                "Version": "Verze",
                "Cab Style": "Cab Style",
                "Series": "\u0158ada",
                "Engine": "Motor",
                "Drive": "Pohon",
                "Axle Ratio": "P\u0159evodov\u00fd pom\u011br diferenci\u00e1lu",
                "Emission": "Emise",
                "Territory": "Oblast",
                "Paint": "Barva",
                "Interior Colour": "Barva interi\u00e9ru",
                "Interior Fabric": "Proveden\u00ed interi\u00e9ru",
                "Trim": "Trim",
                "Body": "Karoserie",
                "Color (interior)": "Barva (interi\u00e9r)",
                "Number of Seats": "Po\u010det sedadel",
                "Number of Seat Rows": "Po\u010det \u0159ad sedadel",
                "Number of Doors": "Po\u010det dve\u0159\u00ed",
                "Number of Airbags": "Po\u010det airbag\u016f",
                "Number of Axles": "Po\u010det n\u00e1prav",
                "Steering": "\u0158\u00edzen\u00ed",
                "Length (mm)": "D\u00e9lka (mm)",
                "Width (mm)": "\u0160\u00ed\u0159ka (mm)",
                "Height (mm)": "V\u00fd\u0161ka (mm)",
                "Weight Empty (kg)": "V\u00e1ha (kg)",
                "Track Front (mm)": "Rozchod kol p\u0159edn\u00ed n\u00e1pravy (mm)",
                "Track Rear (mm)": "Rozchod kol zadn\u00ed n\u00e1pravy (mm)",
                "Wheelbase (mm)": "Rozvor n\u00e1prav (mm)",
                "Wheel Size": "Velikost kol",
                "Fuel Type - Primary": "Palivo - prim\u00e1rn\u00ed",
                "Fuel Type - Secondary": "Palivo - sekund\u00e1rn\u00ed",
                "Fuel Capacity": "Obsah n\u00e1dr\u017ee (l)",
                "Fuel Consumption l\/100km (Combined)": "Spot\u0159eba kombinovan\u00e1 l\/100km",
                "Fuel Consumption l\/100km (Extra Urban)": "Spot\u0159eba mimo m\u011bsto l\/100km",
                "Fuel Consumption l\/100km (Urban)": "Spot\u0159eba ve m\u011bst\u011b l\/100km",
                "Engine (full)": "Motor (v\u0161e)",
                "Engine Code": "K\u00f3d motoru",
                "Engine Displacement (ccm)": "Zdvihov\u00fd objem (ccm)",
                "Engine Power (kW)": "V\u00fdkon motoru (kW)",
                "Engine Cylinders": "Po\u010det v\u00e1lc\u016f",
                "Engine Torque": "To\u010div\u00fd moment (Nm)",
                "Engine Compression Ratio": "Komprese",
                "Engine Model": "Typ motoru",
                "Transmission": "P\u0159evodovka",
                "Transmission (full)": "P\u0159evodovka (v\u0161e)",
                "Number of Gears": "Po\u010det p\u0159evod\u016f",
                "Battery Info": "Baterie",
                "Battery Type": "Typ baterie",
                "Made": "Datum v\u00fdroby",
                "Registered": "Datum registrace",
                "Odometer (km)": "Stav tachometru (km)",
                "Emission Standard": "Emisn\u00ed standard",
                "CO2 Emission": "Emise CO2 (g\/km)",
                "CO2 Emission (Average)": "Emise CO2 (Pr\u016fm\u011br)",
                "Price": "Cena",
                "Price Original": "Price Original",
                "Price Currency": "M\u011bna",
                "Air Conditioning": "Klimatizace",
                "Vehicle not affected.": "Vozidlo nen\u00ed ovlivn\u011bno af\u00e9rou dieselgate.",
                "Vehicle affected.": "<strong>Vozidlo <a href=\":url\" target=\"_blank\">ovlivn\u011bno<\/a><\/strong>.",
                "Plant code": "Zem\u011b p\u016fvodu",
                "Manufacturer Address": "Adresa v\u00fdrobce",
                "Product Type": "Kategorie",
                "Check Digit": "Kontroln\u00ed sou\u010det",
                "Valid Check Digit": "Znak kontroln\u00edho sou\u010dtu",
                "Check Digit Validity": "Kontroln\u00ed sou\u010det",
                "Model Year": "Modelov\u00fd rok v\u00fdroby",
                "Sequential Number": "S\u00e9riov\u00e9 \u010d\u00edslo",
                "Steering Type": "\u0158\u00edzen\u00ed",
                "Power Steering": "Posilova\u010d \u0159\u00edzen\u00ed",
                "Width including mirrors (mm)": "\u0160\u00ed\u0159ka v\u010detn\u011b zrc\u00e1tek (mm)",
                "Width mirrors folded (mm)": "\u0160\u00ed\u0159ka se sklopen\u00fdmi zrc\u00e1tky (mm)",
                "Ride Height (mm)": "Sv\u011btl\u00e1 v\u00fd\u0161ka (mm)",
                "Approach Angle (\u00b0)": "\u00dahel n\u00e1jezdu (\u00b0)",
                "Departure Angle (\u00b0)": "\u00dahel sjezdu (\u00b0)",
                "Ramp Angle (\u00b0)": "P\u0159echodov\u00fd \u00fahel (\u00b0)",
                "Max Weight (kg)": "Maxim\u00e1ln\u00ed povolen\u00e1 hmotnost (kg)",
                "Minimum volume of Luggage (trunk)": "Minim\u00e1ln\u00ed objem zavazadlov\u00e9ho prostoru",
                "Maximum volume of Luggage (trunk)": "Maxim\u00e1ln\u00ed objem zavazadlov\u00e9ho prostoru",
                "Wheel Rims Size": "Velikost r\u00e1fk\u016f",
                "Front Brakes": "P\u0159edn\u00ed brzdy",
                "Rear Brakes": "Zadn\u00ed brzdy",
                "Front Suspension": "P\u0159edn\u00ed tlumi\u010de",
                "Rear Suspension": "Zadn\u00ed tlumi\u010de",
                "Front Overhang (mm)": "P\u0159esah vp\u0159edu (mm)",
                "Rear Overhang (mm)": "P\u0159esah vzadu (mm)",
                "Drag Coefficient": "Drag Coefficient",
                "Max roof load (kg)": "Max zat\u00edzen\u00ed st\u0159echy (kg)",
                "Permitted trailer load with brakes 8% (kg)": "Permitted trailer load with brakes 8% (kg)",
                "Permitted trailer load with brakes 12% (kg)": "Permitted trailer load with brakes 12% (kg)",
                "Permitted trailer load without brakes (kg)": "Permitted trailer load without brakes (kg)",
                "Permitted towbar download (kg)": "Permitted towbar download (kg)",
                "Fuel System": "Palivov\u00fd syst\u00e9m",
                "Engine RPM": "Motor - ot\u00e1\u010dky za minutu",
                "Engine Cylinders Position": "Motor - um\u00edst\u011bn\u00ed v\u00e1lc\u016f",
                "Engine Cylinder Bore": "Motor - pr\u016fm\u011br v\u00e1lce",
                "Valves per Cylinder": "Valves per Cylinder",
                "Valve Train": "Valve Train",
                "Engine Position": "Um\u00edst\u011bn\u00ed motoru",
                "Engine Max Speed (rpm)": "Engine Max Speed (rpm)",
                "Engine Manufacturer": "V\u00fdrobce motoru",
                "Engine Oil Capacity (l)": "Objem oleje v motoru (l)",
                "Engine Coolant (l)": "Engine Coolant (l)",
                "Engine Stroke": "Zdvih motoru",
                "Engine Turbine": "Engine Turbine",
                "Max Speed (km\/h)": "Maxim\u00e1ln\u00ed rychlost (km\/h)",
                "Acceleration 0-100 km\/h": "Zrychlen\u00ed 0-100 km\/h",
                "Minimum turning circle (turning diameter)": "Minim\u00e1ln\u00ed pr\u016fm\u011br kruhu p\u0159i oto\u010den\u00ed",
                "Electric Motor Power (kW)": "V\u00fdkon elektrick\u00e9ho motoru (kW)",
                "Electric Motor RPM": "Electric Motor RPM",
                "Electric Motor Torque (Nm)": "Electric Motor Torque (Nm)",
                "ABS": "ABS",
                "Production Started": "Za\u010d\u00e1tek v\u00fdroby",
                "Production Stopped": "Konec v\u00fdroby",
                "Company": "Firma",
                "Date": "Datum",
                "Acceleration 0-100 km\/h (CNG)": "Zrychlen\u00ed 0-100 km\/h (CNG)",
                "Acceleration 0-100 km\/h (LPG)": "Zrychlen\u00ed 0-100 km\/h (LPG)",
                "Acceleration 0-200 km\/h": "Zrychlen\u00ed 0-200 km\/h",
                "Acceleration 0-300 km\/h": "Zrychlen\u00ed 0-300 km\/h",
                "AdBlue Capacity (l)": "Kapacita AdBlue (l)",
                "All Electric Range": "Dojezd na elekt\u0159inu",
                "Average Energy Consumption (kWh\/100 km)": "Pr\u016fm\u011brn\u00e1 spot\u0159eba elekt\u0159iny (kWh\/100 km)",
                "Battery Capacity (kWh)": "Kapacita baterie (kWh)",
                "Climb Angle (\u00b0)": "Climb Angle (\u00b0)",
                "CNG Cylinder Capacity (kg)": "CNG Cylinder Capacity (kg)",
                "CO2 Emission (g\/km) (CNG)": "CO2 Emission (g\/km) (CNG)",
                "CO2 Emission (g\/km) (Ethanol)": "CO2 Emission (g\/km) (Ethanol)",
                "CO2 Emission (g\/km) (LPG)": "CO2 Emission (g\/km) (LPG)",
                "Deceleration 100-0 km\/h": "Zpomalen\u00ed 100-0 km\/h",
                "Deceleration 200-0 km\/h": "Zpomalen\u00ed 200-0 km\/h",
                "Electric Motor Power (HP)": "V\u00fdkon elektrick\u00e9ho motoru (HP)",
                "Electric Motor Torque (RPM)": "Ot\u00e1\u010dky elektrick\u00e9ho motoru (RPM)",
                "Engine Modification": "Engine Modification",
                "Engine Power (HP)": "V\u00fdkon motoru (HP)",
                "Engine Torque (RPM)": "Ot\u00e1\u010dky motoru (RPM)",
                "Fuel Capacity (LPG)": "Kapacita n\u00e1dr\u017ee (LPG)",
                "Fuel Consumption kg\/100km (Combined) (CNG)": "Spot\u0159eba paliva kg\/100km (kombinovan\u00e1) (CNG)",
                "Fuel Consumption kg\/100km (Extra Urban) (CNG)": "Spot\u0159eba paliva kg\/100km (mimo m\u011bsto) (CNG)",
                "Fuel Consumption kg\/100km (Urban) (CNG)": "Spot\u0159eba paliva kg\/100km (m\u011bsto) (CNG)",
                "Fuel Consumption l\/100km (Combined) (Ethanol)": "Spot\u0159eba paliva l\/100km (kombinovan\u00e1) (Ethanol)",
                "Fuel Consumption l\/100km (Combined) (LPG)": "Spot\u0159eba paliva l\/100km (kombinovan\u00e1) (LPG)",
                "Fuel Consumption l\/100km (Extra Urban) (Ethanol)": "Spot\u0159eba paliva l\/100km (mimo m\u011bsto) (Ethanol)",
                "Fuel Consumption l\/100km (Extra Urban) (LPG)": "Spot\u0159eba paliva l\/100km (mimo m\u011bsto) (LPG)",
                "Fuel Consumption l\/100km (Urban) (Ethanol)": "Spot\u0159eba paliva l\/100km (m\u011bsto) (Ethanol)",
                "Fuel Consumption l\/100km (Urban) (LPG)": "Spot\u0159eba paliva l\/100km (m\u011bsto) (LPG)",
                "Max Speed (km\/h) (CNG)": "Maxim\u00e1ln\u00ed rychlost (km\/h) (CNG)",
                "Max Speed (km\/h) (LPG)": "Maxim\u00e1ln\u00ed rychlost (km\/h) (LPG)",
                "Power (HP) (CNG)": "V\u00fdkon (HP) (CNG)",
                "Power (HP) (Ethanol)": "V\u00fdkon (HP) (Ethanol)",
                "Power (HP) (Ice)": "V\u00fdkon (HP) (Ice)",
                "Power (HP) (LPG)": "V\u00fdkon (HP) (LPG)",
                "Torque (CNG)": "Torque (CNG)",
                "Torque (Ethanol)": "Torque (Ethanol)",
                "Torque (Ice)": "Torque (Ice)",
                "Torque (LPG)": "Torque (LPG)",
                "Wading Depth (mm)": "Wading Depth (mm)",
                "Wheel Rims Size Array": "Velikost r\u00e1fk\u016f",
                "Wheel Size Array": "Velikost kol",
                "Wheelbase Array (mm)": "Rozvor n\u00e1prav (mm)",
                "Vehicle Type Approval": "Schv\u00e1len\u00ed typu vozidla",
                "Vehicle Type Approval (short)": "Schv\u00e1len\u00ed typu vozidla (kr\u00e1tk\u00e9)",
                "Brake System": "Brzdov\u00fd syst\u00e9m",
                "Electric Consumption (kWh\/100km)": "Spot\u0159eba elektrick\u00e9 energie (kWh\/100km)",
                "Electric Consumption (kWh\/100km) (WLTP)": "Spot\u0159eba elektrick\u00e9 energie (kWh\/100 km) (WLTP)",
                "Electric Range From (km)": "Elektrick\u00fd dojezd od (km)",
                "Electric Range From (km) (WLTP)": "Elektrick\u00fd dojezd do (km) (WLTP)",
                "Electric Range To (km)": "Elektrick\u00fd dojezd do (km)",
                "Electric Range To (km) (WLTP)": "Elektrick\u00fd dojezd do (km) (WLTP)",
                "Engine Type": "Typ motoru",
                "Number Wheels": "Po\u010det kol",
                "Suspension": "Zav\u011b\u0161en\u00ed",
                "Fuel Consumption l\/100km (Urban) (WLTP)": "Spot\u0159eba paliva l\/100km (m\u011bsto) (WLTP)",
                "CO2 Emission (WLTP)": "Emise CO2 (WLTP)",
                "Minimum Trunk Capacity (l)": "Minim\u00e1ln\u00ed objem zavazadlov\u00e9ho prostoru (l)",
                "Maximum Trunk Capacity (l)": "Maxim\u00e1ln\u00ed objem zavazadlov\u00e9ho prostoru (l)",
                "Fuel Capacity (l)": "Objem palivov\u00e9 n\u00e1dr\u017ee (l)",
                "Fuel Consumption Combined (l\/100km)": "Spot\u0159eba paliva kombinovan\u00e1 (l\/100 km)",
                "Fuel Consumption Extra Urban (l\/100km)": "Spot\u0159eba paliva mimo m\u011bsto (l\/100km)",
                "Fuel Consumption Urban (l\/100km)": "Spot\u0159eba paliva ve m\u011bst\u011b (l\/100km)",
                "Engine Cylinder Bore (mm)": "Motor - pr\u016fm\u011br v\u00e1lce (mm)",
                "Engine Stroke (mm)": "Zdvih motoru (mm)",
                "CO2 Emission (g\/km)": "Emise CO2 (g\/km)",
                "Average CO2 Emission (g\/km)": "Pr\u016fm\u011brn\u00e9 emise CO2 (g\/km)"
            },
            "cs.frontendValidation": {
                "All good": "V\u0161e v po\u0159\u00e1dku",
                "There are errors": "Opravte chyby",
                "can't be blank": "Nesm\u00ed b\u00fdt pr\u00e1zdn\u00e9",
                "minimum %{count} chars": "minimum %{count} znak\u016f",
                "maximum %{count} chars": "maximum %{count} znak\u016f",
                "is not a valid url": "nen\u00ed validn\u00ed URL",
                "is not a valid email": "nen\u00ed validn\u00ed email",
                "is invalid": "je neplatn\u00e9",
                "is not a number": "nen\u00ed \u010d\u00edslo",
                "is not an integer": "nen\u00ed cel\u00e9 \u010d\u00edslo",
                "must be greater than %{count}": "mus\u00ed b\u00fdt v\u011bt\u0161\u00ed ne\u017e %{count}",
                "must be greater than or equal to %{count}": "mus\u00ed b\u00fdt v\u011bt\u0161\u00ed nebo rovno %{count}",
                "must be equal to %{count}": "mus\u00ed b\u00fdt p\u0159esn\u011b %{count}",
                "must be less than %{count}": "mus\u00ed b\u00fdt men\u0161\u00ed ne\u017e %{count}",
                "must be less than or equal to %{count}": "mus\u00ed b\u00fdt men\u0161\u00ed nebo rovno %{count}",
                "must be odd": "mus\u00ed b\u00fdt lich\u00e9",
                "must be even": "must b\u00fdt sud\u00e9",
                "Must be checked": "Mus\u00ed b\u00fdt za\u0161krtnuto",
                "There is a problem with the Billing Address": "Faktura\u010dn\u00ed \u00fadaje nejsou spr\u00e1vn\u00e9",
                "Card holder name is not valid": "Jm\u00e9no dr\u017eitele karty nen\u00ed spr\u00e1vn\u00e9",
                "Card number is not valid": "\u010c\u00edslo karty nen\u00ed spr\u00e1vn\u00e9",
                "Security code is not valid": "CVC k\u00f3d nen\u00ed spr\u00e1vn\u00fd",
                "Expiry date is not valid": "Datum expirace nen\u00ed spr\u00e1vn\u00e9",
                "Card is Expired": "Karta ji\u017e expirovala",
                "Card data are not valid": "\u00dadaje o kart\u011b nejsou spr\u00e1vn\u00e9",
                "At least one must be greater than zero": "Alespo\u0148 jedno pole mus\u00ed b\u00fdt v\u011bt\u0161\u00ed ne\u017e nula",
                "VAT ID must begin with a country code": "DI\u010c mus\u00ed za\u010d\u00ednat k\u00f3dem zem\u011b",
                "Invalid VAT ID": "Neplatn\u00e9 DI\u010c"
            },
            "cs.chart": {
                "Market Value Dynamics: :car": "Vývoj tržní hodnoty: :car",
                "Average price (:currency)": "Pr\u016fm\u011brn\u00e1 cena (:currency)",
                "Average odometer (:unit)": "Pr\u016fm\u011brn\u00fd n\u00e1jezd (:unit)",
                "Price (:currency)": "Cena (:currency)",
                "Vehicle Price Map: :car": "Cenová mapa nabídek: :car",
                "Odometer (:unit)": "N\u00e1jezd (:unit)",
                "Market value: :make :model (:year)": "Tr\u017en\u00ed hodnota: :make :model (:year)",
                "Price (:currency) \/ Odometer (:lengthUnit): :make :model (:year)": "Cena (:currency) \/ N\u00e1jezd (:lengthUnit): :make :model (:year)",
                "Count of vehicles": "Po\u010det vozidel",
                "Vehicle Market Value": "Tržní hodnota vozidla",
                "Get real insight into a vehicle market.": "Získejte skutečný přehled o tržní ceně vozidel.",
                "Following charts provide several layers of information that are key to making informed decisions. No matter whether you're looking to buy, sell or just evaluate a vehicle.": "Nasledujúce grafy poskytujú niekoľko vrstiev informácií, ktoré sú kľúčové pre prijímanie informovaných rozhodnutí. Bez ohľadu na to, či chcete kúpiť, predať alebo len ohodnotiť vozidlo.",
                "Model Year": "Rok v\u00fdroby",
                "Market Value Dynamics": "Vývoj tržní hodnoty",
                "Vehicle Price Map": "Cenová mapa nabídek",
                "Vehicle Price Distribution: :make :model :year": "Četnosti cen :make :model :year",
                "Vehicle Price Distribution": "Rozložení nabídek na trhu",
                "Date": "Datum",
                "Mileage": "Po\u010det najet\u00fdch kilometr\u016f",
                "Car mileage": "Ujet\u00e9 kilometry auta podle najet\u00fdch kilometr\u016f",
                "Vehicle mileage": "Stav tachometru podle ujetých kilometrů",
                'Number of vehicle listings in the price range': 'Počet nabídek vozidel v daném cenovém rozpětí.',
                "Trendline": "Trendová čára",
                "Vehicle Value Depreciation": "Vývoj hodnoty vozidla",
            }
        }
    },
    pl: {
        langDomain: "pl",
        locale: "pl",
        messages: {
            "pl.messages": {
                "The VIN must be 17 characters.": "Numer VIN sk\u0142ada si\u0119 z 17 znak\u00f3w.",
                "More": "Wi\u0119cej",
                "Close": "Close",
                "Something went wrong": "Something went wrong.",
                "Saved": "Saved.",
                "Price history": "Price history",
                "Odometer history": "Odometer history"
            },
            "pl.my": {"You have to agree to the Terms and Conditions and Privacy Policy": "You have to agree to the Terms and Conditions and Privacy Policy"},
            "pl.payment": {
                "We were unable to process your order.": "We were unable to process your order.",
                "Failed to finish your purchase. Please contact customer support!": "Failed to finish your purchase. Please contact customer support!"
            },
            "pl.vehicle": {
                "WMI": "WMI",
                "Manufacturer": "Producent",
                "Market": "Rynek",
                "Make": "Marka",
                "Model": "Model",
                "Vehicle Specification": "Vehicle Specification",
                "Vehicle Type": "Typ pojazdu",
                "Total weight": "Waga",
                "Length": "D\u0142ugo\u015b\u0107",
                "Engine power": "Moc silnika",
                "queries": "zapytania",
                "Plate": "Tablica rejestracyjna",
                "Color": "Kolor",
                "Evidenced since": "Data pierwszej rejestracji",
                "Last seen at": "Last seen at",
                "International code": "Kod pa\u0144stwa",
                "Year": "Rocznik",
                "Motor": "Silnik",
                "Plant Company": "Kod zak\u0142adu producenta",
                "Plant City": "Miasto produkcji",
                "Plant State": "Stan produkcji",
                "Plant Country": "Kraj produkcji",
                "Equipment": "Wyposa\u017cenie",
                "Build Date": "Data produkcji",
                "Vehicle Line": "Vehicle Line",
                "Body Style": "Styl nadwozia",
                "Version": "Wersja",
                "Cab Style": "Styl wn\u0119trza",
                "Series": "Seria",
                "Engine": "Silnik",
                "Drive": "Nap\u0119d",
                "Axle Ratio": "Rozstaw osi",
                "Emission": "Emisja CO\u2082",
                "Territory": "Region",
                "Paint": "Lakier",
                "Interior Colour": "Kolor wn\u0119trza",
                "Interior Fabric": "Rodzaj tapicerki",
                "Trim": "Trim",
                "Body": "Nadwozie",
                "Color (interior)": "Kolor (wn\u0119trze)",
                "Number of Seats": "Liczba miejsc",
                "Number of Seat Rows": "Liczba rz\u0119d\u00f3w",
                "Number of Doors": "Ilo\u015b\u0107 drzwi",
                "Number of Airbags": "Liczba poduszek powietrznych",
                "Number of Axles": "Number of Axles",
                "Steering": "Uk\u0142ad kierowniczy",
                "Length (mm)": "D\u0142ugo\u015b\u0107 (mm)",
                "Width (mm)": "Szeroko\u015b\u0107 (mm)",
                "Height (mm)": "Wysoko\u015b\u0107 (mm)",
                "Weight Empty (kg)": "Masa w\u0142asna (kg)",
                "Track Front (mm)": "Rozstaw k\u00f3\u0142 przednich (mm)",
                "Track Rear (mm)": "Rozstaw k\u00f3\u0142 tylnych (mm)",
                "Wheelbase (mm)": "Rozstaw osi (mm)",
                "Wheel Size": "Rozmiar opon",
                "Fuel Type - Primary": "Rodzaj paliwa - g\u0142\u00f3wny",
                "Fuel Type - Secondary": "Rodzaj paliwa - pomocniczy",
                "Fuel Capacity": "Pojemno\u015b\u0107 zbiornika paliwa (l)",
                "Fuel Consumption l\/100km (Combined)": "Zu\u017cycie paliwa l\/100km (\u015brednie)",
                "Fuel Consumption l\/100km (Extra Urban)": "Zu\u017cycie paliwa l\/100km (cykl pozamiejski)",
                "Fuel Consumption l\/100km (Urban)": "Zu\u017cycie paliwa l\/100km (cykl miejski)",
                "Engine (full)": "Silnik (full)",
                "Engine Code": "Kod silnika",
                "Engine Displacement (ccm)": "Pojemno\u015b\u0107 skokowa (cm3)",
                "Engine Power (kW)": "Moc silnika (kW)",
                "Engine Cylinders": "Liczba cylindr\u00f3w",
                "Engine Torque": "Moment obrotowy (Nm)",
                "Engine Compression Ratio": "Engine Compression Ratio",
                "Engine Model": "Model silnika",
                "Transmission": "Skrzynia bieg\u00f3w",
                "Transmission (full)": "Skrzynia bieg\u00f3w (full)",
                "Number of Gears": "Liczba bieg\u00f3w",
                "Battery Info": "Akumulator",
                "Battery Type": "Typ akumulatora",
                "Made": "Wyprodukowany w",
                "Registered": "Zarejestrowany",
                "Odometer (km)": "Licznik (km)",
                "Emission Standard": "Standard emisji spalin",
                "CO2 Emission": "Emisja CO2 (g\/km)",
                "CO2 Emission (Average)": "Emisja CO2 (\u015brednia)",
                "Price": "Cennik",
                "Price Original": "Cena oryginalna",
                "Price Currency": "Cena w przeliczeniu",
                "Air Conditioning": "Klimatyzacja",
                "Vehicle not affected.": "Nie dotyczy pojazdu.",
                "Vehicle affected.": "<strong> <a href=\":url\" target=\"_blank\">Dotyczy pojazdu<\/a><\/strong>.",
                "Plant code": "Miejsce produkcji",
                "Manufacturer Address": "Adres producenta",
                "Product Type": "Product Type",
                "Check Digit": "Cyfra kontrolna",
                "Valid Check Digit": "Wa\u017cna cyfra kontrolna",
                "Check Digit Validity": "Wa\u017cno\u015b\u0107 cyfry kontrolnej",
                "Model Year": "Rok modelowy",
                "Sequential Number": "Numer sekwencyjny",
                "Steering Type": "Steering Type",
                "Power Steering": "Power Steering",
                "Width including mirrors (mm)": "Width including mirrors (mm)",
                "Width mirrors folded (mm)": "Width mirrors folded (mm)",
                "Ride Height (mm)": "Ride Height (mm)",
                "Approach Angle (\u00b0)": "Approach Angle (\u00b0)",
                "Departure Angle (\u00b0)": "Departure Angle (\u00b0)",
                "Ramp Angle (\u00b0)": "Ramp Angle (\u00b0)",
                "Max Weight (kg)": "Max Weight (kg)",
                "Minimum volume of Luggage (trunk)": "Minimum volume of Luggage (trunk)",
                "Maximum volume of Luggage (trunk)": "Maximum volume of Luggage (trunk)",
                "Wheel Rims Size": "Wheel Rims Size",
                "Front Brakes": "Front Brakes",
                "Rear Brakes": "Rear Brakes",
                "Front Suspension": "Front Suspension",
                "Rear Suspension": "Rear Suspension",
                "Front Overhang (mm)": "Front Overhang (mm)",
                "Rear Overhang (mm)": "Rear Overhang (mm)",
                "Drag Coefficient": "Drag Coefficient",
                "Max roof load (kg)": "Max roof load (kg)",
                "Permitted trailer load with brakes 8% (kg)": "Permitted trailer load with brakes 8% (kg)",
                "Permitted trailer load with brakes 12% (kg)": "Permitted trailer load with brakes 12% (kg)",
                "Permitted trailer load without brakes (kg)": "Permitted trailer load without brakes (kg)",
                "Permitted towbar download (kg)": "Permitted towbar download (kg)",
                "Fuel System": "Fuel System",
                "Engine RPM": "Engine RPM",
                "Engine Cylinders Position": "Engine Cylinders Position",
                "Engine Cylinder Bore": "Engine Cylinder Bore",
                "Valves per Cylinder": "Valves per Cylinder",
                "Valve Train": "Valve Train",
                "Engine Position": "Engine Position",
                "Engine Max Speed (rpm)": "Engine Max Speed (rpm)",
                "Engine Manufacturer": "Producent silnika",
                "Engine Oil Capacity (l)": "Engine Oil Capacity (l)",
                "Engine Coolant (l)": "Engine Coolant (l)",
                "Engine Stroke": "Engine Stroke",
                "Engine Turbine": "Engine Turbine",
                "Max Speed (km\/h)": "Max Speed (km\/h)",
                "Acceleration 0-100 km\/h": "Acceleration 0-100 km\/h",
                "Minimum turning circle (turning diameter)": "Minimum turning circle (turning diameter)",
                "Electric Motor Power (kW)": "Electric Motor Power (kW)",
                "Electric Motor RPM": "Electric Motor RPM",
                "Electric Motor Torque (Nm)": "Electric Motor Torque (Nm)",
                "ABS": "ABS",
                "Production Started": "Production Started",
                "Production Stopped": "Production Stopped",
                "Company": "Company",
                "Date": "Datum",
                "Acceleration 0-100 km\/h (CNG)": "Acceleration 0-100 km\/h (CNG)",
                "Acceleration 0-100 km\/h (LPG)": "Acceleration 0-100 km\/h (LPG)",
                "Acceleration 0-200 km\/h": "Acceleration 0-200 km\/h",
                "Acceleration 0-300 km\/h": "Acceleration 0-300 km\/h",
                "AdBlue Capacity (l)": "AdBlue Capacity (l)",
                "All Electric Range": "All Electric Range",
                "Average Energy Consumption (kWh\/100 km)": "Average Energy Consumption (kWh\/100 km)",
                "Battery Capacity (kWh)": "Battery Capacity (kWh)",
                "Climb Angle (\u00b0)": "Climb Angle (\u00b0)",
                "CNG Cylinder Capacity (kg)": "CNG Cylinder Capacity (kg)",
                "CO2 Emission (g\/km) (CNG)": "CO2 Emission (g\/km) (CNG)",
                "CO2 Emission (g\/km) (Ethanol)": "CO2 Emission (g\/km) (Ethanol)",
                "CO2 Emission (g\/km) (LPG)": "CO2 Emission (g\/km) (LPG)",
                "Deceleration 100-0 km\/h": "Deceleration 100-0 km\/h",
                "Deceleration 200-0 km\/h": "Deceleration 200-0 km\/h",
                "Electric Motor Power (HP)": "Electric Motor Power (HP)",
                "Electric Motor Torque (RPM)": "Electric Motor Torque (RPM)",
                "Engine Modification": "Engine Modification",
                "Engine Power (HP)": "Engine Power (HP)",
                "Engine Torque (RPM)": "Engine Torque (RPM)",
                "Fuel Capacity (LPG)": "Fuel Capacity (LPG)",
                "Fuel Consumption kg\/100km (Combined) (CNG)": "Fuel Consumption kg\/100km (Combined) (CNG)",
                "Fuel Consumption kg\/100km (Extra Urban) (CNG)": "Fuel Consumption kg\/100km (Extra Urban) (CNG)",
                "Fuel Consumption kg\/100km (Urban) (CNG)": "Fuel Consumption kg\/100km (Urban) (CNG)",
                "Fuel Consumption l\/100km (Combined) (Ethanol)": "Fuel Consumption l\/100km (Combined) (Ethanol)",
                "Fuel Consumption l\/100km (Combined) (LPG)": "Fuel Consumption l\/100km (Combined) (LPG)",
                "Fuel Consumption l\/100km (Extra Urban) (Ethanol)": "Fuel Consumption l\/100km (Extra Urban) (Ethanol)",
                "Fuel Consumption l\/100km (Extra Urban) (LPG)": "Fuel Consumption l\/100km (Extra Urban) (LPG)",
                "Fuel Consumption l\/100km (Urban) (Ethanol)": "Fuel Consumption l\/100km (Urban) (Ethanol)",
                "Fuel Consumption l\/100km (Urban) (LPG)": "Fuel Consumption l\/100km (Urban) (LPG)",
                "Max Speed (km\/h) (CNG)": "Max Speed (km\/h) (CNG)",
                "Max Speed (km\/h) (LPG)": "Max Speed (km\/h) (LPG)",
                "Power (HP) (CNG)": "Power (HP) (CNG)",
                "Power (HP) (Ethanol)": "Power (HP) (Ethanol)",
                "Power (HP) (Ice)": "Power (HP) (Ice)",
                "Power (HP) (LPG)": "Power (HP) (LPG)",
                "Torque (CNG)": "Torque (CNG)",
                "Torque (Ethanol)": "Torque (Ethanol)",
                "Torque (Ice)": "Torque (Ice)",
                "Torque (LPG)": "Torque (LPG)",
                "Wading Depth (mm)": "Wading Depth (mm)",
                "Wheel Rims Size Array": "Wheel Rims Size Array",
                "Wheel Size Array": "Wheel Size Array",
                "Wheelbase Array (mm)": "Wheelbase Array (mm)",
                "Vehicle Type Approval": "Homologacja typu pojazdu",
                "Vehicle Type Approval (short)": "homologacja typu pojazdu (kr\u00f3tka)",
                "Brake System": "Uk\u0142ad hamulcowy",
                "Electric Consumption (kWh\/100km)": "Zu\u017cycie energii elektrycznej (kWh\/100km)",
                "Electric Consumption (kWh\/100km) (WLTP)": "Zu\u017cycie energii elektrycznej (kWh\/100km) (WLTP)",
                "Electric Range From (km)": "Zasi\u0119g elektryczny od (km)",
                "Electric Range From (km) (WLTP)": "Zasi\u0119g elektryczny od (km) (WLTP)",
                "Electric Range To (km)": "Zasi\u0119g elektryczny do (km)",
                "Electric Range To (km) (WLTP)": "Zasi\u0119g elektryczny do (km) (WLTP)",
                "Engine Type": "Typ silnika",
                "Number Wheels": "Liczba k\u00f3\u0142",
                "Suspension": "Zawieszenie",
                "Fuel Consumption l\/100km (Urban) (WLTP)": "Zu\u017cycie paliwa l\/100km (miejskie) (WLTP)",
                "CO2 Emission (WLTP)": "Emisja CO2 (WLTP),",
                "Minimum Trunk Capacity (l)": "Minimum Trunk Capacity (l)",
                "Maximum Trunk Capacity (l)": "Maximum Trunk Capacity (l)",
                "Fuel Capacity (l)": "Pojemno\u015b\u0107 zbiornika paliwa (l)",
                "Fuel Consumption Combined (l\/100km)": "Zu\u017cycie paliwa w po\u0142\u0105czeniu (l\/100km)",
                "Fuel Consumption Extra Urban (l\/100km)": "Zu\u017cycie paliwa poza miastem (l\/100km)",
                "Fuel Consumption Urban (l\/100km)": "Zu\u017cycie paliwa w mie\u015bcie (l\/100km)",
                "Engine Cylinder Bore (mm)": "Silnik Otw\u00f3r cylindra (mm)",
                "Engine Stroke (mm)": "Skok silnika (mm)",
                "CO2 Emission (g\/km)": "Emisja CO2 (g\/km)",
                "Average CO2 Emission (g\/km)": "\u015arednia emisja CO2 (g\/km)"
            },
            "pl.frontendValidation": {
                "All good": "All good",
                "There are errors": "There are errors",
                "can't be blank": "can't be blank",
                "minimum %{count} chars": "min %{count} znak\u00f3w",
                "maximum %{count} chars": "max %{count} znak\u00f3w",
                "is not a valid url": "is not a valid url",
                "is not a valid email": "is not a valid email",
                "is invalid": "is invalid",
                "is not a number": "is not a number",
                "is not an integer": "is not an integer",
                "must be greater than %{count}": "must be greater than %{count}",
                "must be greater than or equal to %{count}": "must be greater than or equal to %{count}",
                "must be equal to %{count}": "musi sk\u0142ada\u0107 si\u0119 z %{count}",
                "must be less than %{count}": "must be less than %{count}",
                "must be less than or equal to %{count}": "must be less than or equal to %{count}",
                "must be odd": "must be odd",
                "must be even": "must be even",
                "Must be checked": "Must be checked",
                "There is a problem with the Billing Address": "There is a problem with the Billing Address",
                "Card holder name is not valid": "Card holder name is not valid",
                "Card number is not valid": "Card number is not valid",
                "Security code is not valid": "Card CVC is not valid",
                "Expiry date is not valid": "Expiry date is not valid",
                "Card is Expired": "Card is Expired",
                "Card data are not valid": "Card data are not valid",
                "At least one must be greater than zero": "At least one must be greater than zero",
                "VAT ID must begin with a country code": "VAT ID must begin with a country code",
                "Invalid VAT ID": "Invalid VAT ID"
            },
            "pl.chart": {
                "Market Value Dynamics: :car": "Market Value Dynamics: :car",
                "Average price (:currency)": "Average price (:currency)",
                "Average odometer (:unit)": "Average odometer (:unit)",
                "Price (:currency)": "Price (:currency)",
                "Vehicle Price Map: :car": "Vehicle Price Map: :car",
                "Odometer (:unit)": "Odometer (:unit)",
                "Market value: :make :model (:year)": "Market value: :make :model (:year)",
                "Price (:currency) \/ Odometer (:lengthUnit): :make :model (:year)": "Price (:currency) \/ Odometer (:lengthUnit): :make :model (:year)",
                "Count of vehicles": "Count of vehicles",
                "Vehicle Market Value": "Vehicle Market Value",
                "Get real insight into a vehicle market.": "Get real insight into a vehicle market.",
                "Following charts provide several layers of information that are key to making informed decisions. No matter whether you're looking to buy, sell or just evaluate a vehicle.": "Following charts provide several layers of information that are key to making informed decisions. No matter whether you're looking to buy, sell or just evaluate a vehicle.",
                "Model Year": "Model Year",
                "Market Value Dynamics": "Dynamika wartości rynkowej",
                "Vehicle Price Map": "Mapa cen pojazdów",
                "Vehicle Price Distribution: :make :model :year": "Vehicle Price Distribution: :make :model :year",
                "Vehicle Price Distribution": "Rozkład cen pojazdów",
                "Date": "Date",
                "Mileage": "Mileage",
                "Car mileage": "Car mileage by kilometers driven",
                "Vehicle mileage": "Odometer reading by kilometres driven",
                'Number of vehicle listings in the price range': 'Number of vehicle listings in the price range.',
                "Trendline": "Trendline",
                "Vehicle Value Depreciation": "Amortyzacja wartości pojazdu",
            }
        }
    }
}
